export default __webpack_public_path__ + "static/media/silver-bordered-fritillary-butterfly-nature-orangePixabay.2a3926a5.jpg";